const validator = require('../../../../../components/textfield/validator.min')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const purchaseSnack = require('./purchase-snack')

let pendingPurchaseEmail = null;
let purchaseInvoiceEmailSending = false;

function getPurchaseEmailState(htmlFc) {
  let check = htmlFc.fullcontHTML.querySelector("#purchase_send_email input");
  let inputEmail = htmlFc.fullcontHTML.querySelector("#purchase_form_email input");
  let mail = inputEmail != undefined ? inputEmail.value.trim() : "";
  let elem = document.querySelector("#purchase-fullcont");
  let dbid = elem != undefined ? elem.getAttribute("data-dbid") : null;

  return {
    checked: check != undefined ? check.checked : false,
    email: mail,
    dbid: dbid
  };
}

export function capturePurchaseEmail(htmlFc) {
  pendingPurchaseEmail = getPurchaseEmailState(htmlFc);
  return pendingPurchaseEmail;
}

export function purchaseSendEmail(detail, htmlFc, emailState = null) {
  let state = emailState || pendingPurchaseEmail || getPurchaseEmailState(htmlFc);
  pendingPurchaseEmail = null;

  let inputEmail = htmlFc.fullcontHTML.querySelector("#purchase_form_email input");
  let elem = document.querySelector("#purchase-fullcont");
  let currentDbid = elem != undefined ? elem.getAttribute("data-dbid") : null;
  let dbid = state.dbid || currentDbid;

  if (!state.checked) {
    return false;
  }

  if (!state.email || !validator.isEmail(state.email)) {
    if (inputEmail != undefined) {
      textfieldHandler.error(inputEmail.closest(".textfield"));
    }
    return false;
  }

  sendInvoicePurchase(dbid, state.email, htmlFc);
  return true;
}

export function sendPurchaseInvoiceEmail(detail, htmlFc) {
  if (purchaseInvoiceEmailSending) return false;

  const fullcontHTML = htmlFc && htmlFc.fullcontHTML;
  const emailContainer = fullcontHTML && fullcontHTML.isConnected
    ? fullcontHTML.querySelector('#purchase_form_email')
    : null;
  const inputEmail = emailContainer ? emailContainer.querySelector('input') : null;
  const email = inputEmail ? inputEmail.value.trim() : '';
  const dbid = fullcontHTML ? fullcontHTML.getAttribute('data-dbid') : null;

  if (!email || !validator.isEmail(email)) {
    if (emailContainer) {
      textfieldHandler.error(emailContainer);
    }

    purchaseSnack.start({
      act: 'show',
      id: 'emailResult',
      text: !email
        ? 'Provider email is required.'
        : 'Enter a valid provider email.'
    });
    return false;
  }

  return sendInvoicePurchase(dbid, email, htmlFc, detail);
}

export function sendInvoicePurchase(dbid = null, email = null, htmlFc = null, detail = null) {
  if (!dbid) return;

  let input_email = document.querySelector('#purchase_form_email input');
  let emailValue = email != null ? email : (input_email != undefined ? input_email.value.trim() : "");

  return sendmail({
    email: emailValue,
    type: "sendinvoice",
    dbid: dbid,
    entity: 'purchase'
  }, htmlFc, detail);
}

function sendmail(data, htmlFc, detail = null) {
  if (purchaseInvoiceEmailSending) return false;

  purchaseInvoiceEmailSending = true;

  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);

  fetch(`./server/php/send-emails/sendEmail.php`, {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  })
    .then(res => {
      clearTimeout(timeout);
      return res.json();
    })
    .then(result => {
      purchaseSnack.start({
        act: 'show',
        id: 'emailResult',
        text: result.message || "An error occurred while sending the email. Recharge"
      });
    })
    .catch(err => {
      clearTimeout(timeout);
      purchaseSnack.start({
        act: 'show',
        id: 'emailResult',
        text: err.name === 'AbortError'
          ? 'The email request timed out.'
          : 'An error occurred while communicating with the server.'
      });
    })
    .finally(() => {
      purchaseInvoiceEmailSending = false;
    });

  return true;
}
